module.exports = __webpack_public_path__ + "static/media/wavy_blob.e4b92717.svg";